/**
 * FAQ Page Functionality
 */

document.addEventListener('DOMContentLoaded', function() {

  // Initialize FAQ functionality
  initializeFAQ();

  function initializeFAQ() {
    // Set up category switching
    setupCategorySwitching();

    // Set up mobile category collapse (mobile only)
    if (window.innerWidth <= 750) {
      setupMobileCategoryCollapse();
    }

    // Set up FAQ collapsible functionality
    setupFAQCollapse();

    // Expand first FAQ item by default
    expandFirstFAQ();
  }

  /**
   * Category Switching Functionality
   */
  function setupCategorySwitching() {
    const categoryItems = document.querySelectorAll('.faq-page__category-item');
    const categoryContents = document.querySelectorAll('.faq-page__category-content');

    categoryItems.forEach(item => {
      item.addEventListener('click', function() {
        const categoryId = this.getAttribute('data-category');

        // Remove active class from all categories
        categoryItems.forEach(cat => cat.classList.remove('active'));
        categoryContents.forEach(content => content.classList.remove('active'));

        // Add active class to clicked category
        this.classList.add('active');

        // Show corresponding content
        const targetContent = document.getElementById('category-' + categoryId);
        if (targetContent) {
          targetContent.classList.add('active');

          // Reset all FAQ items in the new category to closed state
          resetFAQItems(targetContent);

          // Expand first FAQ item in the new category
          expandFirstFAQInCategory(targetContent);
        }
      });
    });
  }

  /**
   * Mobile Category Collapse Functionality
   * Shows only active category by default, expands on tap
   */
  function setupMobileCategoryCollapse() {
    const categoriesContainer = document.querySelector('.faq-page__categories');
    const categoryItems = document.querySelectorAll('.faq-page__category-item');

    if (!categoriesContainer || categoryItems.length === 0) return;

    // Make active category toggle the list
    categoryItems.forEach(item => {
      const originalClickHandler = item.onclick;

      item.addEventListener('click', function(e) {
        const isActive = this.classList.contains('active');
        const isExpanded = categoriesContainer.classList.contains('expanded');

        if (isActive && !isExpanded) {
          // Expand to show all categories
          e.stopPropagation();
          e.preventDefault();
          categoriesContainer.classList.add('expanded');
        } else if (!isActive) {
          // Collapse after selection (with small delay to show selection)
          setTimeout(() => {
            categoriesContainer.classList.remove('expanded');
          }, 100);
        }
      }, true); // Use capture phase to run before category switching
    });

    // Close when clicking outside
    document.addEventListener('click', function(e) {
      if (!categoriesContainer.contains(e.target)) {
        categoriesContainer.classList.remove('expanded');
      }
    });
  }

  /**
   * FAQ Collapsible Functionality
   */
  function setupFAQCollapse() {
    const faqQuestions = document.querySelectorAll('[data-faq-toggle]');

    faqQuestions.forEach(question => {
      question.addEventListener('click', function() {
        const faqItem = this.closest('.faq-page__faq-item');
        const isOpen = faqItem.classList.contains('open');

        if (isOpen) {
          // Close this item
          closeFAQItem(faqItem);
        } else {
          // Close all other items in the same category first
          const categoryContent = this.closest('.faq-page__category-content');
          const allFAQItems = categoryContent.querySelectorAll('.faq-page__faq-item');
          allFAQItems.forEach(item => {
            if (item !== faqItem) {
              closeFAQItem(item);
            }
          });

          // Open this item
          openFAQItem(faqItem);
        }
      });
    });
  }

  /**
   * Open FAQ Item
   */
  function openFAQItem(faqItem) {
    faqItem.classList.add('open');

    // Update icon
    const icon = faqItem.querySelector('.faq-page__faq-icon');
    if (icon) {
      icon.textContent = '−';
    }

    // Animate answer height
    const answer = faqItem.querySelector('.faq-page__faq-answer');
    if (answer) {
      const content = answer.querySelector('.faq-page__faq-answer-content');
      answer.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  /**
   * Close FAQ Item
   */
  function closeFAQItem(faqItem) {
    faqItem.classList.remove('open');

    // Update icon
    const icon = faqItem.querySelector('.faq-page__faq-icon');
    if (icon) {
      icon.textContent = '+';
    }

    // Animate answer height
    const answer = faqItem.querySelector('.faq-page__faq-answer');
    if (answer) {
      answer.style.maxHeight = '0px';
    }
  }

  /**
   * Reset all FAQ items to closed state
   */
  function resetFAQItems(categoryContent) {
    const allFAQItems = categoryContent.querySelectorAll('.faq-page__faq-item');
    allFAQItems.forEach(item => {
      closeFAQItem(item);
    });
  }

  /**
   * Expand first FAQ item by default
   */
  function expandFirstFAQ() {
    const activeCategory = document.querySelector('.faq-page__category-content.active');
    if (activeCategory) {
      expandFirstFAQInCategory(activeCategory);
    }
  }

  /**
   * Expand first FAQ item in a specific category
   */
  function expandFirstFAQInCategory(categoryContent) {
    const firstFAQItem = categoryContent.querySelector('.faq-page__faq-item');
    if (firstFAQItem) {
      // Small delay to ensure smooth animation
      setTimeout(() => {
        openFAQItem(firstFAQItem);
      }, 100);
    }
  }

  /**
   * Smooth scroll to FAQ section when switching categories
   */
  function scrollToFAQContent() {
    const contentArea = document.querySelector('.faq-page__content');
    if (contentArea && window.innerWidth <= 990) {
      contentArea.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  /**
   * Handle window resize
   */
  function handleResize() {
    // Recalculate FAQ answer heights on resize
    const openFAQItems = document.querySelectorAll('.faq-page__faq-item.open');
    openFAQItems.forEach(item => {
      const answer = item.querySelector('.faq-page__faq-answer');
      const content = answer.querySelector('.faq-page__faq-answer-content');
      if (answer && content) {
        answer.style.maxHeight = content.scrollHeight + 'px';
      }
    });

    // Reset mobile category collapse when resizing to desktop
    if (window.innerWidth > 750) {
      const categoriesContainer = document.querySelector('.faq-page__categories');
      if (categoriesContainer) {
        categoriesContainer.classList.remove('expanded');
      }
    }
  }

  // Add resize event listener
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 250);
  });

  /**
   * Keyboard navigation support
   */
  function setupKeyboardNavigation() {
    const categoryItems = document.querySelectorAll('.faq-page__category-item');
    const faqQuestions = document.querySelectorAll('[data-faq-toggle]');

    // Make category items focusable
    categoryItems.forEach(item => {
      item.setAttribute('tabindex', '0');
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    // Make FAQ questions focusable
    faqQuestions.forEach(question => {
      question.setAttribute('tabindex', '0');
      question.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  // Initialize keyboard navigation
  setupKeyboardNavigation();

});